function getAverasgeOfTwo(x,y){
    return ( x + y )/2
}

export default getAverasgeOfTwo
